import React from 'react'
import hexagonBorderSrc from 'shared/assets/images/hexagon-border-2x.png'
import styled from 'styled-components'

type Props = {
    src: string,
    disabled?: boolean,
    small?: boolean
}

/*
 * Hexagon border rendering a centered icon
 * */
const BlazonHexagonBorder = (props: Props) => {
    const { src, disabled = false, small = false } = props

    return (
        <Root>
            <Img src={hexagonBorderSrc} disabled={disabled} />
            <IconContainer>
                <Img src={src} disabled={disabled} small={small} />
            </IconContainer>
        </Root>
    )
}

const Root = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`

const Img = styled.img`
    width: ${props => (props.small ? '80%' : '100%')};
    height: ${props => (props.small ? '80%' : '100%')};
    object-fit: contain;
    ${({ disabled }) => disabled && 'filter: grayscale(1);'}}
`

const IconContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: inherit;
    height: inherit;
    padding: 10%;
    box-sizing: border-box;
`

export { BlazonHexagonBorder }
